@if (modalVisible()) {
<div class="fixed inset-0 flex justify-center items-center z-[9999] px-4 bg-[rgba(39,43,52,0.24)]" (click)="onClose()">
  <div class="{{
      modalService.customModalClasses() && modalService.customModalClasses().trim() !== ''
        ? modalService.customModalClasses()
        : getModalClasses()
    }}" [style]="getModalWidthStyle()" (click)="$event.stopPropagation()">
    <!-- Content container with 24px padding -->
    <div class="flex flex-col items-center w-full" [ngClass]="modalVariant === 'legacy' ? 'gap-6' : 'gap-6'">

      <!-- Icon container: 72px height, full width, centered -->
      <div class="w-full h-[72px] flex items-center justify-center flex-shrink-0">
        @if (modalService.useIcon()) {
        <div class="relative flex items-center justify-center">
          <div class="absolute rounded-full" [style.width.px]="getCircleSizes().outer"
            [style.height.px]="getCircleSizes().outer" [style.background-color]="getIconShadowColor()"></div>

          <i [ngClass]="[
                getIconClass(),
                getIconColor(),
                'relative z-10 flex items-center justify-center'
              ]" [style.width.px]="getIconSize()" [style.height.px]="getIconSize()"
            [style.line-height.px]="getIconSize()" [style.color]="modalService.iconColor() || null">
          </i>
        </div>
        } @else if (modalService.imageUrl()) {
        @if (modalService.imageUrl().endsWith('.svg') && modalService.imageUrl().includes('exclamation')) {
          <div class="w-[72px] h-[72px] rounded-full bg-[#FFF2D2] flex items-center justify-center p-4">
            <img [ngSrc]="modalService.imageUrl()" alt="Modal icon" class="w-10 h-10 object-contain" 
              width="40" height="40" loading="lazy" />
          </div>
        } @else {
          <picture>
            <source [srcset]="modalService.imageUrl()" type=".webp" />
            <img [ngSrc]="modalService.imageUrl()" alt="Modal icon" 
              [ngClass]="modalService.imageUrl().endsWith('.svg') ? 'w-10 h-10 object-contain' : 'w-48 h-42 object-cover'" 
              [width]="modalService.imageUrl().endsWith('.svg') ? 40 : 192"
              [height]="modalService.imageUrl().endsWith('.svg') ? 40 : 168" 
              loading="lazy" />
          </picture>
        }
        }
      </div>

      <!-- Text container: flex-1 for growth, auto width -->
      <div class="w-full flex flex-col items-center justify-start flex-shrink-0">
        @if (modalService.showCloseIcon()) {
        <div class="flex items-center justify-between w-full mb-2">
          @if (modalService.planName()) {
          <h2 class="{{ getTitleClasses() }} text-left m-0 flex-1 min-w-0" [style]="modalVariant === 'legacy' ? 'font-weight: 600; font-size: 22px; line-height: 24px; letter-spacing: 0%;' : ''">
            <span>{{ modalService.title() }}</span>
            <app-tooltip [text]="modalService.planName()" position="top" [fullWidth]="true">
              <span class="truncate block">{{ modalService.planName() }}</span>
            </app-tooltip>
          </h2>
          } @else {
          <app-tooltip [text]="modalService.title()" position="top" [fullWidth]="true" class="flex-1 min-w-0">
            <h2 class="{{ getTitleClasses() }} text-left m-0 truncate" [style]="modalVariant === 'legacy' ? 'font-weight: 600; font-size: 22px; line-height: 24px; letter-spacing: 0%;' : ''">
              {{ modalService.title() }}
            </h2>
          </app-tooltip>
          }
          <button class="ml-2 text-xl text-neutrals-n100 hover:text-black-50 flex-shrink-0" (click)="onClose()"
            aria-label="Cerrar">
            <i class="fi fi-ss-cross {{
                  modalService.showCloseIconCustomClasses()
                }}"></i>
          </button>
        </div>
        } @else {
        @if (modalService.planName() && modalService.planName().trim()) {
        <app-tooltip [text]="modalService.title() + ' ' + modalService.planName()" position="top" [fullWidth]="true">
          <h2 class="w-full text-center modal-delete-title" style="font-family: Poppins; font-weight: 600; font-size: 22px; line-height: 24px; letter-spacing: 0%; color: #1A212B; margin: 0; margin-bottom: 12px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; word-break: break-word; overflow-wrap: break-word;">
            {{ modalService.title() }}{{ modalService.planName() }}
          </h2>
        </app-tooltip>
        } @else {
        <h2 class="{{ getTitleClasses() }} mb-2 w-full" [style]="modalVariant === 'legacy' ? 'font-weight: 600; font-size: 22px; line-height: 24px; letter-spacing: 0%;' : ''">
          {{ modalService.title() }}
        </h2>
        }
        }

        @if (modalService.message()) {
        <p class="w-full text-center" [class]="modalService.planName() ? '' : getMessageClasses()" [style]="modalService.planName() ? 'font-family: Poppins; font-weight: 500; font-size: 14px; line-height: 20px; letter-spacing: 0%; color: #1A212B; margin: 0;' : ''">
          {{ modalService.message() }}
        </p>
        }
      </div>

      <!-- Form container: w-full (separated from text container) -->
      @if (modalService.bodyForm()) {
      <div class="w-full flex-shrink-0">
        <form [formGroup]="modalService.bodyForm()!" class="w-full">
          @for (controlName of controls; track controlName) {
          <div class="w-full">
            <input type="text"
              class="w-full px-4 py-3 min-h-12 rounded-2xl border leading-none focus:outline-none placeholder:text-text-placeholder text-base overflow-hidden text-ellipsis"
              [class.border-soft-gray]="!modalService.bodyForm()!.get(controlName)!.invalid || !modalService.bodyForm()!.get(controlName)!.touched"
              [class.border-error]="modalService.bodyForm()!.get(controlName)!.invalid && modalService.bodyForm()!.get(controlName)!.touched"
              placeholder="Ingresar" [formControlName]="controlName" maxlength="50" />
          </div>

          @if (modalService.bodyForm()!.get(controlName)!.invalid && modalService.bodyForm()!.get(controlName)!.touched)
          {
          <div class="flex items-start mt-2 text-error w-full max-w-[392px] h-9 pl-4" style="gap: 4px;">
            <i class="fi fi-sr-triangle-warning text-base py-2.5 flex-shrink-0"></i>
            <small class="font-poppins font-normal text-[12px] leading-[18px] text-[#B1000F] flex-1">
              {{ getErrorMessage(controlName) }}
            </small>
          </div>
          }
          }
        </form>
      </div>
      }

      <!-- Buttons container: w-full with separator on top -->
      @if (modalService.btnCancelar() || modalService.btnContinue() || modalService.btnMiddle()) {
      <div class="w-full pt-4 border-t border-secundary-b700">
        <div [ngClass]="modalVariant === 'legacy' ? 'flex flex-col min-[481px]:flex-row gap-4 w-full' : (modalService.planName() || modalService.bodyForm() ? 'flex flex-row gap-4 w-full' : 'flex flex-col min-[481px]:flex-row gap-4 w-full')">
          @if (modalService.btnCancelar()) {
          <button class="{{ getButtonClasses('secondary') }}" [ngClass]="modalVariant === 'legacy' ? 'w-full min-[481px]:flex-1 min-[481px]:!w-auto' : (modalService.planName() ? 'w-[131.5px] s:!w-[188px]' : modalService.bodyForm() ? 'w-[122px] s:!w-[188px]' : 'w-full min-[481px]:!w-[188px]')" style="height: 48px;" (click)="onClose(true)">
            {{ modalService.cancelButtonText() || "Cancelar" }}
          </button>
          }

          @if(modalService.btnMiddle()){
          <div [ngClass]="modalVariant === 'legacy' ? 'w-full min-[481px]:flex-1 min-[481px]:!w-auto' : (modalService.planName() ? 'w-[131.5px] s:!w-[188px]' : modalService.bodyForm() ? 'w-[141px] s:!w-[188px]' : 'w-full min-[481px]:!w-[188px]')" style="height: 48px;">
            <app-buttons [type]="'primary'"
              [text]="modalService.buttonTextMiddle()" size="custom" [responsiveClasses]="'w-full'"
              [fullWidth]="true"
              (click)="onConfirmMiddle()" [additionalClasses]="'h-12 !px-0'" />
          </div>
          }

          @if(modalService.btnContinue()){
          <div [ngClass]="modalVariant === 'legacy' ? 'w-full min-[481px]:flex-1 min-[481px]:!w-auto' : (modalService.planName() ? 'w-[131.5px] s:!w-[188px]' : modalService.bodyForm() ? 'w-[141px] s:!w-[188px]' : 'w-full min-[481px]:!w-[188px]')" style="height: 48px;">
            <app-buttons [type]="modalService.isLoading() ? 'loader' : modalService.continueButtonType()"
              [text]="modalService.continueButtonText() || 'Continuar'" size="custom" [responsiveClasses]="'w-full h-12'"
              [disabled]="!modalService.btnContinueIsEnabled()" [loading]="modalService.isLoading()" [fullWidth]="true"
              (click)="onConfirmClick()" [additionalClasses]="''" />
          </div>
          }
        </div>
      </div>
      }
    </div>

    <ng-content></ng-content>
  </div>
</div>
}